import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { Router } from '../../../node_modules/@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  @ViewChild('container', { static: true }) container: ElementRef;
  navIsFixed: boolean = false;

  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    console.log('main comp');
    
    // let token = localStorage.getItem('token');
    // if (!token) {
    //   return this.router.navigate(['/login']);
    // }
  }

  scrollToTop($element) {
    this.container.nativeElement.scrollTop = 0;
  }

  scrollChanged(event) {
    if (event > 10) {
      this.navIsFixed = true;
    } else {
      this.navIsFixed = false;
    }
  }


}
